import React from "react";
import Item from "../../../../shared/item/Item";
import styles from "./PricingHeader.module.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";
import { Table, TableHead } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import {
  CheckBoxTableCellHeader,
  NonEditTableHeader,
  PermissionHeader,
  SpecsTableHeaderPricingDetails,
  WarningTableCell,
} from "../../../../shared/pricing/dealerFees/TableComponents";
import HasPermissionTo from "../../../../common/HasPermissionTo";

const PricingHeader = (props) => {
  const editEnabled = props.isEditEnabled;

  const headers = [
    {
      id: "yearItem",
      key: "year",
      translation: props.t("PricingHeader.year"),
      sorting: true,
    },
    {
      id: "RRPItem",
      key: "rrp",
      translation: props.t("PricingHeader.rrp"),
      sorting: true,
    },
    {
      id: "VMItem",
      key: "totalCustomerSaving",
      translation: props.t("PricingHeader.offers"),
      sorting: true,
      variableMarketing:
        props.user.userType === "nsc" ||
        (props.user.userType === "dealer" && props.user.market !== "NOR"),
    },
    { id: "dealerAdjustment" },
    {
      id: "dealerVehiclePrice",
      key: "dealerVehiclePrice",
      translation: props.t("PricingHeader.dealerVehiclePrice"),
      sorting: true,
    },
    {
      id: "transPriceItem",
      key: "transactionPrice",
      translation: props.t("PricingHeader.dealerTransactionPrice"),
      sorting: true,
    },
  ];

  const sort = (index) => !editEnabled && props.onSort(index);

  function dealerAdjustment() {
    return (
      <PermissionHeader
        {...props}
        condition={!props.user.readOnly}
        editEnabled={editEnabled}
        headerTestId="dealerAdjustmentUpdateHeader"
        headerText={props.t("PricingHeader.dealerAdjustment")}
        updateText={props.t("PricingHeader.update")}
        bodyText={props.t("PricingHeader.dealerAdjustment")}
        noRenderText={props.t("PricingHeader.dealerAdjustment")}
        cancelTestId="cancelPricing"
        confirmTestId="confirmPricing"
        editTestId="editPricing"
      />
    );
  }

  function tableHeader(header) {
    return (
      <NonEditTableHeader id={header.id} onClick={() => sort(header.key)}>
        <div
          className={`${styles.vehiclesHeaderWrap} ${styles.vehiclesHeader}`}
        >
          <Item
            value={
              header.variableMarketing
                ? `${props.t("VariableMarketing.header")} ${header.translation}`
                : header.translation
            }
          />
          <span className={styles.sorting}>
            <SortingIcon
              currentKey={header.key}
              hide={
                header.id === "yearItem"
                  ? !(
                      Array.isArray(props.catalogIds) &&
                      props.catalogIds.length > 1
                    )
                  : editEnabled
              }
              sortKey={props.sortKey}
              sortDirection={props.sortDirection}
            />
          </span>
        </div>
      </NonEditTableHeader>
    );
  }

  return (
    <div className={`${styles.rowBorder}`}>
      <Table>
        <TableHead>
          <WarningTableCell />
          <CheckBoxTableCellHeader>
            <CheckBox
              className="toggleAllCheckbox"
              id="toggleAllCheckbox"
              checked={false}
              isDisabled={props.isDisabled}
            />
          </CheckBoxTableCellHeader>

          <SpecsTableHeaderPricingDetails
            id="specs"
            onClick={() => sort("specs")}
          >
            <div className={styles.specsHeaderWrap}>
              <Item value={props.t("PricingHeader.specification")} />
              <span className={styles.sorting}>
                <SortingIcon
                  currentKey="specs"
                  hide={editEnabled}
                  sortKey={props.sortKey}
                  sortDirection={props.sortDirection}
                />
              </span>
            </div>
          </SpecsTableHeaderPricingDetails>

          {headers.map((header) => {
            if (header.id !== "dealerAdjustment") {
              return tableHeader(header);
            } else {
              return (
                <HasPermissionTo
                  perform={["dealerAdjustment"]}
                  permissions={props.user.permissions.rolePermissions}
                  render={() => {
                    return dealerAdjustment();
                  }}
                />
              );
            }
          })}
        </TableHead>
      </Table>
    </div>
  );
};

export default withTranslation("emp")(PricingHeader);
